var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCanIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/General/Export Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "@-Product-details-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prod-detail/Nutri-info-11",
    transform: "translate(-871.000000, -1283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(30.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(40.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-5",
    transform: "translate(0.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(425.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-Copy-5",
    transform: "translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Delete",
    transform: "translate(373.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,2.5 L12.5,2.5 L12.5,3.3203125 L16.6796875,3.3203125 L16.6796875,5 L15.8203125,5 L15.8203125,15.8203125 C15.8203125,16.2890648 15.6640641,16.6861963 15.3515625,17.0117188 C15.0390609,17.3372412 14.6484398,17.5 14.1796875,17.5 L5.8203125,17.5 C5.35156016,17.5 4.96093906,17.3372412 4.6484375,17.0117188 C4.33593594,16.6861963 4.1796875,16.2890648 4.1796875,15.8203125 L4.1796875,5 L3.3203125,5 L3.3203125,3.3203125 L7.5,3.3203125 L7.5,2.5 Z M5.8203125,5 L5.8203125,15.8203125 L14.1796875,15.8203125 L14.1796875,5 L5.8203125,5 Z M7.5,6.6796875 L9.1796875,6.6796875 L9.1796875,14.1796875 L7.5,14.1796875 L7.5,6.6796875 Z M10.8203125,6.6796875 L12.5,6.6796875 L12.5,14.1796875 L10.8203125,14.1796875 L10.8203125,6.6796875 Z",
    id: "Icon",
    fill: "#5B616B"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanIcon);
export default __webpack_public_path__ + "static/media/TrashCanIcon.15c56ecf7d51732217d9aef5a5a0fe59.svg";
export { ForwardRef as ReactComponent };